export const nounbrPath = (nounbrId: Number) => `/nounbr/${nounbrId}`;
